import {
  IconCalendar,
  IconChevronLeft,
  IconChevronRight,
  IconEdit,
  IconEye,
  IconReload,
  IconTrash,
  IconSearch,
} from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DinamicTitle } from '../../utils/DinamicTitle';
import DetailTransaksiPembelian from './DetailTransaksiPembelian';
// import Tooltip from '../../utils/Tooltip';
import { Tooltip } from 'antd';
import ConfirmationTransferModal from './ConfirmationTransferModal';
import moment from 'moment';
import Input from '../../components/Input';
import EditTrxPembelian from './EditTrxPembelian';
import { IconPhotoEdit } from '@tabler/icons-react';
import ConfirmationDeletePembelian from '../../components/Admin/ConfirmationDeletePembelian';
import useKarat from '../features/useKarat';
import LoadingIndicator from '../../components/LoadingIndicator';

const TrxPembelian = () => {
  const navigate = useNavigate();
  const [submitPembelian, setSubmitPembelian] = useState(false);
  const [isSubmitEdit, setIsSubmitEdit] = useState(false);

  const [trxPembelian, setTrxPembelian] = useState([]);
  const [detailPembelian, setDetailPembelian] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pembelian_id, setIdTrxPembelian] = useState('');
  // const [teknisi_id, setTeknisi] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  // const [isSubmitBarangOpname, setIsSubmitBarangOpname] = useState(false);

  const [show, setShow] = useState(false);
  const [submitChange, setSubmitChange] = useState(false);
  let [isOpen, setIsOpen] = useState(false);

  const [kategori, setKategori] = useState([]);
  // console.log('kategori::: ', kategori);
  const [selectCabang, setSelectCabang] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState('');

  // FILTER STATE
  const [idCabang, setIdCabang] = useState(0);
  const [idKategori, setIdKategori] = useState(0);
  const [openCalender, setOpenCalender] = useState(false);
  const [kodeTransaksi, setKodeTransaksi] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [deleteId, setDeleteId] = useState('');
  const [openLoading, setOpenLoading] = useState(false);
  const [loadingDel, setLoadingDel] = useState(false);
  const [pembelianDelete, setPembelianDelete] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  let [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();

  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  const filterBeratBarang = () => {
    setFilterBerat(filterBerat);
  };

  function closeModalDelete() {
    setIsOpenModalDelete(false);
  }

  function openModalDelete() {
    setIsOpenModalDelete(true);
  }

  // function handleOnChangeTeknisi(e) {
  //   setTeknisi(e.target.value);
  // }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  async function getTrxPembelian() {
    setLoading(true);
    await http
      .get(
        `pembelian${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${(idCabang === 0 || idCabang === '') ? `` : `&cabang=${idCabang}`}${(selectedKategori === 0 || selectedKategori === '') ? `` : `&kategori=${selectedKategori}`}${(selectJenisKategori === 0 || selectJenisKategori === '') ? `` : `&jenis_kategori=${selectJenisKategori}`
        }${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`}${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${filterBerat === '' ? '' : `&berat=${filterBerat}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setLastPage(res.data.data.last_page);
        setCurrentPage(res.data.data.current_page);
        setItemsPerPage(res.data.data.per_page);
        setTrxPembelian(res.data.data.data);
        return res.data.data.data;
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response?.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    getTrxPembelian();
  }, [
    isSubmit === true,
    isSubmitEdit == true,
    idCabang,
    search.length >= 12 ? search : '',
    currentPage,
    startDate,
    endDate,
    awal,
    akhir,
    // idKategori,
    karatOptionId,
    filterBerat,
    selectedKategori,
    selectJenisKategori,
  ]);

  async function getIdPembelian(id) {
    setShow(true);
    setSubmitChange(true);
    await http
      .get(`/pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        // console.log('res::: ', res);
        setKodeTransaksi(res.data.data.kode_trx);
        setIdTrxPembelian(res.data.data.id);
        setDetailPembelian(res.data.data);
        setIsOpen(true);
        return res.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    setSubmitChange(false);
    setShow(false);
  }

  // async function addToOpname() {
  //   const data = { pembelian_id, teknisi_id };
  //   setIsSubmitBarangOpname(true);
  //   try {
  //     const response = await http.post(`/stok-opname`, data, {
  //       headers: { Authorization: getAuthorizationHeader() },
  //     });
  //     setIsOpen(false);
  //     setIsSubmit(true);
  //     setIsSubmitBarangOpname(false);
  //     toast.success(response.data.message);
  //     return response.data;
  //   } catch (error) {
  //     if (error.response.status === 409) {
  //       toast.error(error.response.data.message);
  //     } else if (error.response.status === 422) {
  //       toast.warning('Silahkan Masukkan Teknisi');
  //     }
  //   }
  //   setIsSubmitBarangOpname(false);
  // }

  function closeModal() {
    setIsOpen(false);
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  DinamicTitle('Transaksi Pembelian || Komaladewi');

  // GET CABANG FILTER
  useEffect(() => {
    async function getCabangSelect() {
      await http
        .get(`cabang?is_toko=1`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setSelectCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getCabangSelect();
  }, []);
  // END GET CABANG FILTER

  // GET KATEGORI FILTER
  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          // console.log('res::: ', res);
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, []);

  // TRANFER ITEM

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;
  const [loadingEditPembelian, setLoadingEditPembelian] = useState(false);
  let [isOpenEditTrx, setIsOpenEditTrx] = useState(false);

  function closeModalEditTrx() {
    setIsOpenEditTrx(false);
  }

  function openModalEditTrx() {
    setIsOpenEditTrx(true);
  }
  const [idEdit, setIdEdit] = useState('');
  // const [berat, setBerat] = useState('');
  const [karat, setKarat] = useState('');
  const [kondisi_barang, setKondisiBarang] = useState('');
  const [harga_beli, setHargaBeli] = useState('');
  const [jenis_kategori_id, setJenisKategoriIdBase] = useState('');
  const [is_change_harga, setIsChange] = useState(false);
  const [gambar, setGambar] = useState(null);
  // console.log({
  //   jenis_kategori_id, berat, karat, harga_beli, is_change_harga, gambar
  // })

  const [idEditPembelian, setIdEditPembelian] = useState([]);
  async function getIdEditPembelian(id) {
    setLoadingEditPembelian(true);
    await http
      .get(`/pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategoriIdBase(res.data.data.jenis_kategori_id);
        setIdEditPembelian(res.data.data);
        setKondisiBarang(res.data.data.kondisi_barang);
        openModalEditTrx();
        setIdEdit(res.data.data.id);
        setBerat(res.data.data.berat);
        setHargaBeli(res.data.data.harga_beli);
        setKarat(res.data.data.karat);
        // setGambar(res.data.data.gambar[0].asli);
        return res.data;
      })
      .catch((err) => {
        if (err.response?.status == 422) {
          toast.warning('Periksa data yang diubah', { autoClose: 600, });
        }
        console.log(err.response);
      });
    setLoadingEditPembelian(false);
  }
  const [isSelected, setIsSelected] = useState(false);
  async function editTrxPembelian(e) {
    e.preventDefault();
    setSubmitPembelian(true);
    setIsSubmitEdit(true);

    try {
      const data = { berat, harga_beli, karat, gambar, jenis_kategori_id, is_change_harga, kondisi_barang };
      const response = await http.put(`pembelian/${idEdit}`, data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      toast.success(response.data.message || 'Data berhasil diupdate', { autoClose: 600, });
      closeModalEditTrx();
      setSubmitPembelian(false);
      setIsSelected(false);
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        toast.warning('Waktu permintaan ke server habis', { autoClose: 600, });
      } else {
        console.log(error);
      }
    }
    setTimeout(() => {
      setSubmitPembelian(false);
    }, 1000);
    setTimeout(() => {
      setIsSubmitEdit(false);
    }, 1000);
  }

  async function getIdDelete(id) {
    setLoadingDel(true);
    await http
      .get(`pembelian/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        openModalDelete();
        setDeleteId(res.data.data.id);
        setPembelianDelete(res.data.data);
        setLoadingDel(false);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingDel(false);
  }

  async function deletePembelian() {
    setIsDelete(true);
    await http
      .delete(`pembelian/${deleteId}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModalDelete();
        toast.success(res.data.message, { autoClose: 600, });
        getTrxPembelian();
      })
      .catch((err) => {
        console.log(err);
      });
    setIsDelete(false);
  }

  return (
    <Layouts
      dateFilter={`${awal === 'Invalid date' ? '' : ` : ${awal}`} ${awal == akhir ? `` : `${akhir === 'Invalid date' ? '' : ` s/d ${akhir}`}`}`}
      title={'Transaksi Pembelian'}
      compFilter={
        <div className="flex items-center gap-2">
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              onClick={() => setOpenCalender(!openCalender)}
              className="bg-amber-500 hover:bg-amber-600 dark:bg-amber-600 dark:hover:bg-amber-700 transition flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md cursor-pointer shadow-sm"
              title="Filter Tanggal"
            >
              <IconCalendar className="text-white w-5 h-5" />
            </div>
            <div tabIndex={0} className={`dropdown-content -left-20 sm:-left-40 mt-1 z-50 p-2 shadow-lg rounded-md bg-white dark:bg-slate-800 border dark:border-slate-700`}>
              <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} className="dark:text-slate-800" />
            </div>
          </div>
          <div
            onClick={() => window.location.reload()}
            className="bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600 transition flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md cursor-pointer shadow-sm"
            title="Refresh Halaman"
          >
            <IconReload className="text-white w-5 h-5" />
          </div>
          <div className="flex justify-end ml-1">
            <Input
              className="input h-[2.5rem] border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
              type="text"
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              placeholder="Masukkan Pembelian"
            />
          </div>
        </div>
      }
    >
      <ConfirmationDeletePembelian
        isDelete={isDelete}
        deletePembelian={deletePembelian}
        pembelianDelete={pembelianDelete}
        isOpenModalDelete={isOpenModalDelete}
        closeModalDelete={closeModalDelete}
      />

      {openLoading || loadingDel ? (
        <LoadingIndicator />
      ) : (
        ''
      )}

      {loadingEditPembelian ? (
        <LoadingIndicator />
      ) : (
        <EditTrxPembelian
          idEditPembelian={idEditPembelian}
          submitPembelian={submitPembelian}
          setJenisKategoriIdBase={setJenisKategoriIdBase}
          setIsChange={setIsChange}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
          gambar={gambar}
          setGambar={setGambar}
          is_change_harga={is_change_harga}
          editTrxPembelian={editTrxPembelian}
          berat={berat}
          karat={karat}
          setKarat={setKarat}
          setKondisiBarang={setKondisiBarang}
          harga_beli={harga_beli}
          setHargaBeli={setHargaBeli}
          setBerat={setBerat}
          isOpenEditTrx={isOpenEditTrx}
          closeModalEditTrx={closeModalEditTrx}
        />
      )}

      <div className="mt-4 md:mt-0">
        <div className="flex items-center justify-between overflow-x-auto pb-0 scrollbar-none">
          <div className="flex items-center bg-white dark:bg-slate-900 justify-center md:justify-start w-full">
            <div>
              <div className="flex gap-2  p-2">
                <select
                  onChange={(e) => setIdCabang(e.target.value)}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Semua Etalase</option>
                  {selectCabang.map((cb) => (
                    <option value={cb.id} key={cb.id}>
                      {cb.nama_cabang}
                    </option>
                  ))}
                </select>
                <select
                  value={selectedKategori}
                  onChange={handleKategoriChange}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Semua Kategori</option>
                  {kategori.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nama_kategori}
                    </option>
                  ))}
                </select>

                {selectedKategori && (
                  <select
                    onChange={handleJenisKategoriChange}
                    value={selectJenisKategori}
                    className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                  >
                    <option value="">Jenis Kategori</option>
                    {kategori
                      .find((kt) => kt.id == selectedKategori)
                      ?.jenis_kategori.map((jk) => (
                        <option key={jk.id} value={jk.id}>
                          {jk.nama_jenis}
                        </option>
                      ))}
                  </select>
                )}

                <select
                  onChange={(e) => setKaratOptionId(e.target.value)}
                  className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                  <option value="">Karat</option>
                  {karatOption.map((kto) => (
                    <option key={kto} value={kto}>
                      {kto}
                    </option>
                  ))}
                </select>
                <div className="flex gap-1 items-center ml-1">
                  <Input
                    onChange={(e) => setFilterBerat(e.target.value)}
                    placeholder="Cari Berat"
                    className="h-[2.5rem] w-32 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none rounded-md transition-colors"
                  />
                  <button onClick={filterBeratBarang} className="bg-amber-500 hover:bg-amber-600 dark:bg-amber-600 dark:hover:bg-amber-700 flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm">
                    <IconSearch className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => {
                      getTrxPembelian();
                    }}
                    className="bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600 flex items-center justify-center text-white h-[2.5rem] w-[2.5rem] rounded-md transition-colors shadow-sm"
                  >
                    <IconReload className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {show ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
            <div className="w-12 h-12  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
          </div>
        ) : (
          <DetailTransaksiPembelian
            // kodeTransaksi={kodeTransaksi}
            // kategori={kategori}
            // isSubmitBarangOpname={isSubmitBarangOpname}
            // submitChange={submitChange}
            detailPembelian={detailPembelian}
            // addToOpname={addToOpname}
            // handleOnChangeTeknisi={handleOnChangeTeknisi}
            closeModal={closeModal}
            isOpen={isOpen}
          />
        )}
        <div className="dark:border-slate-700/60 pt-2 pb-16">
          <div className="inline-block min-w-full shadow-sm sm:rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
            <div className="relative overflow-x-auto scrollbar-thin">
              {loading ? (
                <div className="flex justify-center py-6 w-full items-center">
                  <div className="w-6 h-6 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent mr-2"></div>
                  <div className="font-semibold text-slate-500 dark:text-slate-400">Loading....</div>
                </div>
              ) : (
                <table className="min-w-full leading-normal">
                  <thead className="sticky top-0 z-10">
                    <tr className="bg-gradient-to-r from-amber-50 to-amber-100/70 dark:from-slate-800 dark:to-slate-800/70 border-b border-amber-200/50 dark:border-slate-700">
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        No
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Barang
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Kondisi
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Berat | Karat
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Harga
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Rata | Gram
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap border-r border-amber-200/30 dark:border-slate-700/50">
                        Tanggal
                      </th>
                      <th className="px-5 py-3 text-xs font-semibold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap">
                        Aksi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {trxPembelian.map((trx, i) => (
                      <tr
                        key={trx.id}
                        onClick={() => getIdPembelian(trx.id)}
                        className="hover:bg-amber-50 dark:hover:bg-slate-800/80 bg-white dark:bg-slate-900 cursor-pointer transition-colors border-b border-slate-100 dark:border-slate-700/50"
                      >
                        <td className="px-5 py-3 text-sm">
                          <span className="text-slate-900 dark:text-slate-300 font-medium whitespace-nowrap">{startIndex + i + 1}.</span>
                        </td>
                        <td className="px-5 py-3 whitespace-nowrap text-sm">
                          <span className="text-amber-700 dark:text-amber-500 font-medium">{trx.jenis_kategori?.nama_jenis}</span>
                        </td>
                        <td className="px-5 py-3 text-sm">
                          <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">{trx.kondisi_barang}</span>
                        </td>
                        <td className="px-5 py-3 text-sm">
                          <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">
                            <span className="font-medium">{trx.berat} gr</span> <span className="text-slate-400 dark:text-slate-500">| {trx.karat} krt</span>
                          </span>
                        </td>
                        <td className="px-5 py-3 whitespace-nowrap text-sm text-slate-800 dark:text-slate-300 font-medium">
                          Rp {numberWithCommas(trx.total_harga == undefined ? '0' : trx.total_harga)}
                        </td>
                        <td className="px-5 py-3 text-sm">
                          <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">
                            Rp{' '}
                            {numberWithCommas(
                              trx.total_harga == undefined ? '0' : Math.round(trx.total_harga / trx.berat),
                            )}{' '}
                            <span className="text-slate-400 dark:text-slate-500">/ gr</span>
                          </span>
                        </td>
                        <td className="px-5 py-3 text-sm">
                          <span className="text-slate-800 dark:text-slate-300 whitespace-nowrap">{trx.created_at}</span>
                        </td>
                        <td className="px-5 py-3 flex items-center gap-2 text-sm">
                          <Tooltip title="Edit">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                getIdEditPembelian(trx.id);
                              }}
                              className="w-8 h-8 flex items-center justify-center rounded-md bg-amber-500 text-white hover:bg-amber-600 shadow-sm transition-colors text-xs focus:outline-none"
                            >
                              <IconEdit size={18} stroke={2} />
                            </button>
                          </Tooltip>
                          <Tooltip title="Hapus">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                getIdDelete(trx.id);
                              }}
                              className="w-8 h-8 flex items-center justify-center rounded-md bg-red-500 text-white hover:bg-red-600 shadow-sm transition-colors text-xs focus:outline-none"
                            >
                              <IconTrash size={18} stroke={2} />
                            </button>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="bg-slate-50 dark:bg-slate-800/50 border-t border-slate-200 dark:border-slate-700 py-3 transition-colors">
              <div className="flex justify-end items-center w-full px-5">
                <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-3 sm:flex">
                  <span className="block text-slate-700 dark:text-slate-300 font-medium">
                    Page {currentPage} of {lastPage}{' '}
                  </span>
                  <div className="space-x-1">
                    <button
                      onClick={() => setCurrentPage(currentPage - 1)}
                      title="previous"
                      type="button"
                      className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                    >
                      <IconChevronLeft className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => setCurrentPage(currentPage + 1)}
                      title="next"
                      type="button"
                      className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md shadow-sm transition-colors"
                    >
                      <IconChevronRight className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default TrxPembelian;
